document.querySelectorAll('.solag-product__form').forEach((form) => {
const section = form.closest('.solag-product');
const variantScript = section.querySelector('[data-solag-variants]');
const variantMediaScript = section.querySelector('[data-solag-variant-media]');
const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
const variantMedia = variantMediaScript ? JSON.parse(variantMediaScript.textContent) : [];
const mediaByVariantId = new Map(variantMedia.map((item) => [String(item.id), item.image]).filter((item) => item[1]));
const idInput = form.querySelector('[data-solag-variant-id]');
const addButton = form.querySelector('[data-solag-add]');
const price = section.querySelector('[data-solag-price]');
const moneyFormat = section.dataset.moneyFormat;
const mainMedia = section.querySelector('.solag-product__main-media');
let activeColor = '';
const isSps4Winter = section.dataset.productHandle === 'copy-of-seibertron-youth-sps-4-winter-cold-weather-motorcycle-gloves-rainproof-riding-with-touchscreen-warm-gauntlet-for-boys-and-girls';
const displayOptionValue = (value) => {
if (section.dataset.productHandle === 'seibertron-white-football-gloves') {
return String(value || '').replace(/^Adult\s+/i, '').replace(/^Youth\s+/i, '');
}
if (section.dataset.productHandle === 'seibertron-h-p-i-l-g-touchscreen-football-receiver-gloves-flexible-breathable-impact-protection-back-of-hand-glove-adult-and-youth-sizes') {
if (value === '2XS') return 'XXS';
if (value === '2XL') return 'XXL';
}
if (section.dataset.productHandle === 'seibertron-h-p-i-r-g-touchscreen-white-football-receiver-gloves') {
if (value === '2XS') return 'XXS';
if (value === '2XL') return 'XXL';
}
if (section.dataset.productHandle === 'seibertron-t-t-f-i-g-2-0-tactical-fingerless-gloves') {
return String(value || '').replace(/^(.+?)\s+Adult$/i, 'Adult $1');
}
if (section.dataset.productHandle === 'gloves-for-motorcycle') {
const adultSizeLabels = {
S: 'Adult S',
M: 'Adult M',
L: 'Adult L',
XL: 'Adult XL',
'2XL': 'Adult XXL',
'3XL': 'Adult XXXL'
};
return adultSizeLabels[value] || value;
}
if (section.dataset.productHandle === 'motorcycle-gloves') {
const sps5ColorLabels = {
'SPS-5 White': 'White',
'SPS-5 Black': 'Black',
'SPS-5 Orange': 'Orange',
'SPS-5 Grey': 'Grey',
'SPS-5 Pink': 'Pink',
'SPS-5 FL Yellow': 'Fluorescent Yellow'
};
const youthSizeLabels = { XS: 'Youth XS', S: 'Youth S', M: 'Youth M', L: 'Youth L', XL: 'Youth XL' };
return sps5ColorLabels[value] || youthSizeLabels[value] || value;
}
if (isSps4Winter) {
const youthSizeLabels = { L: 'Youth L', XL: 'Youth XL' };
return youthSizeLabels[value] || value;
}
if (section.dataset.productHandle === 'seibertron-sps-2-unisex-touchscreen-road-racing-motorcycle-mtb-sports-gloves') {
const colorLabels = {
'SPS-2 Full Finger Adult Blue': 'Blue',
'SPS-2 Full Finger Adult White': 'White',
'SPS-2 Full Finger Adult Black': 'Black',
'SPS-2 Full Finger Adult Orange': 'Orange',
'SPS-2 Full Finger Adult FL Yellow': 'Fluorescent Yellow'
};
const adultSizeLabels = {
S: 'Adult S',
M: 'Adult M',
L: 'Adult L',
XL: 'Adult XL',
XXL: 'Adult XXL',
XXXL: 'Adult XXXL'
};
return colorLabels[value] || adultSizeLabels[value] || value;
}
return value;
};
const formatMoney = (cents) => {
if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
return window.Shopify.formatMoney(cents, moneyFormat);
}
return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
};
const sizedImageUrl = (url, width) => {
if (!url) return '';
try {
const parsed = new URL(url, window.location.origin);
parsed.searchParams.set('width', width);
return parsed.toString();
} catch (error) {
return url;
}
};
const normalizeImageKey = (url) => {
if (!url) return '';
try {
const parsed = new URL(url, window.location.origin);
return parsed.pathname.split('/').pop();
} catch (error) {
return String(url).split('?')[0].split('/').pop();
}
};
const normalizeColor = (value) => String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
const colorFromOptionValue = (value) => {
const normalized = normalizeColor(value).replace(/^(adult|youth)\s+/, '');
if (normalized.includes('army green')) return 'army green';
if (normalized.includes('coyote')) return 'coyote';
if (normalized.includes('black')) return 'black';
if (normalized.includes('yellow')) return 'yellow';
if (normalized.includes('blue')) return 'blue';
if (normalized.includes('orange')) return 'orange';
if (normalized.includes('brown')) return 'brown';
if (normalized.includes('white')) return 'white';
if (normalized.includes('red')) return 'red';
if (normalized.includes('pink')) return 'pink';
if (normalized.includes('grey')) return 'grey';
if (normalized.includes('gray')) return 'grey';
return normalized;
};
const colorTagFrom = (text) => {
const match = String(text || '').match(/\bcolor\s*:\s*([^,;|\n\r]+)/i);
// Images without a color marker stay visible as shared images.
return match ? normalizeColor(match[1]) : 'all';
};
const selectedColor = () => {
const colorGroup = Array.from(form.querySelectorAll('[data-solag-option-index]')).find((group) => {
const name = normalizeColor(group.dataset.solagOptionName);
if (name === 'color' || name === 'colour' || name === '颜色') return true;
if (name.includes('style')) {
const checked = group.querySelector('[data-solag-option]:checked');
return checked && colorFromOptionValue(checked.value) !== normalizeColor(checked.value);
}
return false;
});
const checked = colorGroup ? colorGroup.querySelector('[data-solag-option]:checked') : null;
return checked ? colorFromOptionValue(checked.value) : '';
};
const buttonMatchesColor = (button, color) => {
const normalizedColor = normalizeColor(color);
const mediaColor = colorTagFrom(button.dataset.colorTags || button.dataset.mediaAlt || '');
return !normalizedColor || mediaColor === 'all' || mediaColor === normalizedColor;
};
const setButtonVisibility = (button, isVisible) => {
button.hidden = !isVisible;
button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
};
const filterMediaByColor = (color, preferredMedia) => {
const buttons = Array.from(section.querySelectorAll('[data-solag-media-button]'));
if (!buttons.length) return;
let visibleButtons = buttons.filter((button) => buttonMatchesColor(button, color));
if (!visibleButtons.length) visibleButtons = buttons;
buttons.forEach((button) => setButtonVisibility(button, visibleButtons.includes(button)));
const orderedVisibleButtons = [...visibleButtons].sort((first, second) => {
const firstOrder = Number(window.getComputedStyle(first).getPropertyValue('--solag-media-order')) || Number(first.dataset.mediaPosition) || 0;
const secondOrder = Number(window.getComputedStyle(second).getPropertyValue('--solag-media-order')) || Number(second.dataset.mediaPosition) || 0;
return firstOrder - secondOrder;
});
const preferredKey = preferredMedia && preferredMedia.src ? normalizeImageKey(preferredMedia.src) : '';
const preferredButton = preferredKey ? visibleButtons.find((button) => normalizeImageKey(button.dataset.mediaSrc || '') === preferredKey) : null;
const activeButton = visibleButtons.find((button) => button.classList.contains('is-active'));
const targetButton = preferredButton || activeButton || orderedVisibleButtons[0];
const image = targetButton ? targetButton.querySelector('img') : null;
if (targetButton) {
setMainMedia({
src: targetButton.dataset.mediaSrc || (image ? image.src : ''),
alt: targetButton.dataset.mediaAlt || (image ? image.alt : '')
});
}
};
const syncActiveThumbnail = (src) => {
const targetKey = normalizeImageKey(src);
const buttons = section.querySelectorAll('[data-solag-media-button]');
let matched = false;
buttons.forEach((button) => {
const buttonKey = normalizeImageKey(button.dataset.mediaSrc || (button.querySelector('img') || {}).src || '');
const isMatch = targetKey && buttonKey === targetKey;
button.classList.toggle('is-active', isMatch);
if (isMatch) {
matched = true;
if (typeof button.scrollIntoView === 'function') {
button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
}
});
if (!matched) buttons.forEach((button) => button.classList.remove('is-active'));
};
const setMainMedia = (media) => {
if (!mainMedia || !media || !media.src) return;
mainMedia.src = sizedImageUrl(media.src, 1200);
mainMedia.srcset = [500, 700, 900, 1200].map((width) => `${sizedImageUrl(media.src, width)} ${width}w`).join(', ');
if (media.alt) mainMedia.alt = media.alt;
syncActiveThumbnail(media.src);
};
const selectedOptions = () => {
return Array.from(form.querySelectorAll('[data-solag-option-index]')).map((group) => {
const checked = group.querySelector('[data-solag-option]:checked');
return checked ? checked.value : '';
});
};
const isSps4WinterSizeUnavailable = (value, color) => {
if (!isSps4Winter) return false;
if (value === 'XS' || value === 'S' || value === 'M') return true;
return normalizeColor(color) === 'pink' && (value === 'Adult XXL' || value === 'Adult XXXL');
};
const syncSps4WinterSizeAvailability = () => {
if (!isSps4Winter) return;
const sizeGroup = Array.from(form.querySelectorAll('[data-solag-option-index]')).find((group) => normalizeColor(group.dataset.solagOptionName) === 'size');
if (!sizeGroup) return;
const color = selectedColor();
sizeGroup.querySelectorAll('.solag-product__choice').forEach((choice) => {
const input = choice.querySelector('[data-solag-option]');
if (!input) return;
const unavailable = isSps4WinterSizeUnavailable(input.value, color);
choice.hidden = unavailable;
choice.setAttribute('aria-hidden', unavailable ? 'true' : 'false');
input.disabled = unavailable;
});
const checked = sizeGroup.querySelector('[data-solag-option]:checked');
if (!checked || checked.disabled) {
const fallback = sizeGroup.querySelector('[data-solag-option]:not(:disabled)');
if (fallback) {
fallback.checked = true;
sizeGroup.querySelectorAll('.solag-product__choice').forEach((choice) => choice.classList.remove('is-selected'));
fallback.closest('.solag-product__choice').classList.add('is-selected');
}
}
};
const syncSelectedLabels = () => {
form.querySelectorAll('[data-solag-option-index]').forEach((group) => {
const checked = group.querySelector('[data-solag-option]:checked');
const selected = group.querySelector('[data-solag-selected-option]');
if (checked && selected) selected.textContent = displayOptionValue(checked.value);
});
};
const updateVariant = () => {
syncSps4WinterSizeAvailability();
const selected = selectedOptions();
const variant = variants.find((item) => {
return item.options.every((option, index) => option === selected[index]);
});
if (!variant) return;
syncSelectedLabels();
if (idInput) idInput.value = variant.id;
if (price) price.textContent = formatMoney(variant.price);
if (addButton) {
addButton.disabled = !variant.available;
addButton.textContent = variant.available ? addButton.dataset.availableText || addButton.textContent : addButton.dataset.soldOutText || addButton.textContent;
}
const nextColor = normalizeColor(selectedColor());
const colorChanged = nextColor && nextColor !== activeColor;
const variantMedia = mediaByVariantId.get(String(variant.id));
filterMediaByColor(nextColor, colorChanged || !nextColor ? variantMedia : null);
activeColor = nextColor;
};
form.querySelectorAll('[data-solag-option]').forEach((input) => {
input.addEventListener('change', () => {
const fieldset = input.closest('[data-solag-option-index]');
const selected = fieldset ? fieldset.querySelector('[data-solag-selected-option]') : null;
if (fieldset) {
fieldset.querySelectorAll('.solag-product__choice').forEach((choice) => choice.classList.remove('is-selected'));
input.closest('.solag-product__choice').classList.add('is-selected');
}
if (selected) selected.textContent = displayOptionValue(input.value);
updateVariant();
});
});
updateVariant();
});
document.querySelectorAll('[data-solag-media-button]').forEach((button) => {
button.addEventListener('click', () => {
if (button.hidden) return;
const gallery = button.closest('.solag-product__gallery');
const main = gallery ? gallery.querySelector('.solag-product__main-media') : null;
const image = button.querySelector('img');
if (!main || !image) return;
main.src = button.dataset.mediaSrc || image.src.replace('width=160', 'width=1200');
main.srcset = '';
if (button.dataset.mediaAlt) main.alt = button.dataset.mediaAlt;
gallery.querySelectorAll('[data-solag-media-button]').forEach((item) => item.classList.remove('is-active'));
button.classList.add('is-active');
});
});
class SolagRelatedProducts extends HTMLElement {
connectedCallback() {
if (this.dataset.loaded === 'true') return;
this.dataset.loaded = 'true';
const url = this.dataset.url;
if (!url) return;
fetch(url, { credentials: 'same-origin' })
.then((response) => response.text())
.then((text) => {
const html = document.createElement('div');
html.innerHTML = text;
const related = html.querySelector('solag-related-products');
const grid = related ? related.querySelector('.product-grid') : null;
if (grid) {
this.innerHTML = grid.outerHTML;
this.classList.add('is-loaded');
} else {
this.innerHTML = '<p class="solag-product__related-loading">No related products available.</p>';
}
})
.catch(() => {
this.innerHTML = '<p class="solag-product__related-loading">No related products available.</p>';
});
}
}
if (!customElements.get('solag-related-products')) {
customElements.define('solag-related-products', SolagRelatedProducts);
}
